import {useFormContext, useWatch} from "react-hook-form";

import {Heading} from "@/components/typography/heading/Heading.tsx";
import {SlackPreviewSlot} from "@/pages/integrations/edit/subForms/slack/SlackPreviewSlot.tsx";
import {SlackAlertType, SlackCustomizationState} from "@/pages/integrations/edit/subForms/slackInfo.ts";

interface SlackAlertPreviewProps {
  customization: SlackCustomizationState;
  onSendTest: (alertType: SlackAlertType) => void;
}

export const SlackAlertPreview = ({customization, onSendTest}: SlackAlertPreviewProps) => {
  const {control} = useFormContext<{settings: {channel?: string}}>();
  const channel = useWatch({control, name: "settings.channel"}) ?? "the configured channel";
  return (
    <div className="mt-4">
      <div className="d-flex align-items-baseline justify-content-between gap-3 mb-2">
        <Heading as="h6" className="pulseTextBodySmallBold m-0">
          Live preview
        </Heading>
        <div className="pulseTextBodySmall pulse-color-gray-600">
          Click <span className="pulseTextBodySmallBold">'Send test'</span> below a card to post a sample to {channel}.
        </div>
      </div>
      <div className="d-flex flex-column gap-3">
        <SlackPreviewSlot alertType="down" toggles={customization.down} onSendTest={onSendTest} />
        <SlackPreviewSlot alertType="up" toggles={customization.up} onSendTest={onSendTest} />
      </div>
    </div>
  );
};
